<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>站点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="场地名称:">
        <el-select v-model="formInline.station_name" placeholder="请选择部门名称" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.station_name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域:">
        <el-cascader
          size="large"
          :options="pcaTextArr"
          v-model="formInline.area"
          clearable
          change-on-select="true"	>
        </el-cascader>
      </el-form-item>
      <el-form-item label="状态:"  clearable>
        <el-select v-model="formInline.is_disable">
          <el-option label="启用" value="0"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getdata()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="user.role_id == 39">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" width="100">
      </el-table-column>
      <el-table-column sortable prop="station_name" label="场地名称" width="200">
      </el-table-column>
      <el-table-column sortable prop="province" label="区域" width="300">
        <template slot-scope="scope">
           {{scope.row.province}} / {{scope.row.city}} / {{scope.row.county}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="address" label="详细地址" width="300">
      </el-table-column>
      <el-table-column sortable prop="pile_num" label="设备数量" width="100">
      </el-table-column>
      <el-table-column sortable prop="is_disable" label="状态" width="100">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.is_disable == 0" type="success">启用</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.is_disable ==1 ">禁用</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="is_open_white" label="白名单状态" width="100">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.is_open_white == 0" type="success">关闭</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.is_open_white ==1 ">开启</el-button>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="200" >
        <template slot-scope="scope">
          <!-- <router-link target="_blank" :to="{  path: '/system/WhiteUser', query: {station_id: scope.row.id,station_name:scope.row.station_name}}" >
            <el-button type="primary" size="mini" >白名单管理</el-button>
          </router-link> -->
          <el-button size="mini" type="warning"  v-if="scope.row.stationLian == 1"   @click="handleInfo(scope.$index, scope.row)">同步数据</el-button>

          <el-button size="mini" type="primary"  @click="handlePrice(scope.$index, scope.row)">计费规则</el-button>
          <el-button size="mini" type="primary" v-if="user.role_id == 39" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="user.role_id == 39" @click="deleteStation(scope.$index, scope.row)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog title="计价规则" :visible.sync="priceFormVisible" width="50%" @click="closePriceDialog">
      慢充价格
      <el-table size="small" :data="priceInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column sortable prop="id" label="序号" >
        </el-table-column>
        <el-table-column sortable prop="station_name" label="时间" >
          <template slot-scope="scope">
            {{scope.row.open_start_time}}-{{scope.row.open_end_time}}
          </template>
        </el-table-column>
        <el-table-column sortable prop="province" label="参考价" >
          <template slot-scope="scope">
            ¥{{(scope.row.service_price+scope.row.ele_price)/100}} /度
          </template>
        </el-table-column>
        <el-table-column sortable prop="address" label="电费" >
          <template slot-scope="scope">
            ¥{{scope.row.ele_price/100}} /度
          </template>
        </el-table-column>
        <el-table-column sortable prop="pile_num" label="服务费" >
          <template slot-scope="scope">
            ¥{{scope.row.service_price/100}} /度
          </template>
        </el-table-column>
        </el-table>
        快充价格
        <el-table size="small" :data="secondPriceInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column sortable prop="id" label="序号" >
        </el-table-column>
        <el-table-column sortable prop="station_name" label="时间" >
          <template slot-scope="scope">
            {{scope.row.open_start_time}}-{{scope.row.open_end_time}}
          </template>
        </el-table-column>
        <el-table-column sortable prop="province" label="参考价" >
          <template slot-scope="scope">
            ¥{{(scope.row.service_price+scope.row.ele_price)/100}} /度
          </template>
        </el-table-column>
        <el-table-column sortable prop="address" label="电费" >
          <template slot-scope="scope">
            ¥{{scope.row.ele_price/100}} /度
          </template>
        </el-table-column>
        <el-table-column sortable prop="pile_num" label="服务费" >
          <template slot-scope="scope">
            ¥{{scope.row.service_price/100}} /度
          </template>
        </el-table-column>

        </el-table>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="场地名称" prop="station_name">
          <el-input size="small" v-model="editForm.station_name" auto-complete="off" placeholder="请输入场地名称"></el-input>
        </el-form-item>
        <el-form-item label="场地区域" prop="area">
          <el-cascader
            size="xlarge"
            :options="pcaTextArr"
            v-model="editForm.area"
            change-on-select="true"	>
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input size="small" v-model="editForm.address"  placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="场地经度" prop="lon">
          <el-input size="small" v-model="editForm.lon"  placeholder="请输入场地经度"></el-input>
        </el-form-item>
        <el-form-item label="场地纬度" prop="lat">
          <el-input size="small" v-model="editForm.lat"  placeholder="请输入场地纬度"></el-input>
          <a  href="https://lbs.amap.com/tools/picker" target="_blank">高德坐标拾取器</a>
        </el-form-item>
        <el-form-item label="快充计费模型:">
        <el-select v-model="editForm.second_price_id" placeholder="请选择计费模型">
          <el-option v-for="item in priceList" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="慢充计费模型:">
        <el-select v-model="editForm.price_id" placeholder="请选择计费模型">
          <el-option v-for="item in priceList" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" prop="contacts">
        <el-input size="small" v-model="editForm.contacts"  placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contacts_mobile">
        <el-input size="small" v-model="editForm.contacts_mobile"  placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="车场状态:">
        <el-select v-model="editForm.is_disable" placeholder="请选择">
          <el-option v-for="item in status_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="停车减免:">
        <el-select v-model="editForm.is_coupon" placeholder="请选择">
          <el-option v-for="item in open_status_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="减免方式:">
        <el-select v-model="editForm.coupon_type" placeholder="请选择">
          <el-option v-for="item in coupon_type_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="减免值">
        <el-input size="small" v-model="editForm.coupon_value"  placeholder="请输入值"></el-input>
      </el-form-item>


      <!-- <el-form-item label="白名单:">
        <el-select v-model="editForm.is_open_white" placeholder="请选择">
          <el-option v-for="item in open_status_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
        </el-select>
      </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStationNames,getStation,addStation,updateStation,deleteStation,handleInfo } from '../../api/station'
import { getPrice,getPriceByid } from '../../api/price'

import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {
  pcaTextArr,
} from "element-china-area-data";
export default {
  data() {
    return {
      user:{},
      priceList:[],
      pcaTextArr,
      selectedOptions: [],
      station_names:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      priceFormVisible:false,
      title: '添加',
      priceInfoList:[],
      secondPriceInfoList:[],
      editForm: {
        station_name: '',
        area: '',
        address: '',
        lon: '',
        lat: '',
        price_id: '',
        contacts: '',
        contacts_mobile: '',
        is_disable: 0,
        second_price_id:'',
        is_coupon:0,
        coupon_type:2,
        coupon_value:'',
        // is_open_white:0,
      },
      status_names:[{name:'启用',val:0},{name:'禁用',val:1}],
      open_status_names:[{name:'关闭',val:0},{name:'开启',val:1}],
      coupon_type_names:[{name:'免费',val:0},{name:'抵扣金额元',val:1},{name:'抵扣时间分钟',val:2}],
      // rules表单验证
      rules: {
        station_name: [
          { required: true, message: '请输入站点名称', trigger: 'blur' }
        ],

        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        lat: [
          { required: true, message: '请输入经度', trigger: 'blur' }
        ],
        lon: [
          { required: true, message: '请输入纬度', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contacts_mobile: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        station_name: '',
        is_disable: '',
        area:'',
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    this.getStationNames()
    this.getPrice()
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getPrice(){
      getPrice().then(res => {
        if (res.code == 0) {
            this.priceList = res.data.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },

    // 获取公司列表
    getdata() {
      this.loading = true
      this.formInline.province = this.formInline.area.length > 0  ? this.formInline.area[0] :''
      this.formInline.city = this.formInline.area.length > 1  ? this.formInline.area[1] :''
      this.formInline.county = this.formInline.area.length > 2  ? this.formInline.area[2] :''
      getStation(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    handlePrice(index, row) {
      this.priceFormVisible = true
      getPriceByid({id:row.price_id}).then(res => {
        if (res.code == 0) {
            this.priceInfoList = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
      if(row.second_price_id){
        getPriceByid({id:row.second_price_id}).then(res => {
          if (res.code == 0) {
              this.secondPriceInfoList = res.data
          } else {
            this.$message.error(res.message)
            return false
          }
        })
      }

    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.station_name = row.station_name
        this.editForm.address = row.address
        this.editForm.lon = row.lon
        this.editForm.lat = row.lat
        this.editForm.price_id = row.price_id
        this.editForm.contacts = row.contacts
        this.editForm.contacts_mobile = row.contacts_mobile
        this.editForm.is_disable = row.is_disable
        this.editForm.second_price_id = row.second_price_id
        this.editForm.coupon_type = row.coupon_type
        this.editForm.is_coupon = row.is_coupon
        this.editForm.coupon_value = row.coupon_value

        // this.editForm.is_open_white = row.is_open_white
        this.editForm.id = row.id
        this.editForm.area = [row.province,row.city,row.county]
      } else {
        this.title = '添加'
        this.editForm =  {
          station_name: '',
          area: '',
          address: '',
          lon: '',
          lat: '',
          price_id: '',
          contacts: '',
          contacts_mobile: '',
          is_disable: 0,
          second_price_id:'',
          is_coupon:0,
          coupon_type:2,
          coupon_value:'',
          // is_open_white:0,
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.editForm.province = this.editForm.area.length > 0  ? this.editForm.area[0] :''
          this.editForm.city = this.editForm.area.length > 1  ? this.editForm.area[1] :''
          this.editForm.county = this.editForm.area.length > 2  ? this.editForm.area[2] :''
          if(this.editForm.id){
            updateStation(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            addStation(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }

        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteStation(index, row) {
      this.$confirm('此操作将删除该场地, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteStation(row.id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    handleInfo(index, row) {
      this.$message({
        type: 'success',
        message: '开始同步!'
      })
      handleInfo(row.id)
      .then(res => {
        if (res.code == 0 ) {
          this.$message({
            type: 'success',
            message: '同步成功!'
          })
          this.getdata(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('同步失败，请稍后再试！')
      })

    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    closePriceDialog() {
      this.priceFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/station/Station.vue